import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faLock, faUnlockKeyhole } from "@fortawesome/free-solid-svg-icons";
import { BSL_STATUS } from "../Sidebar/utils/sidebarStorage";

const statusConfig = {
  [BSL_STATUS.apply]: {
    label: "Link your BSL Account",
    icon: faLock,
    tone: "apply",
  },
  [BSL_STATUS.pending]: {
    label: "Pending approval",
    icon: faClock,
    tone: "pending",
  },
  [BSL_STATUS.approved]: {
    label: "Active",
    icon: faUnlockKeyhole,
    tone: "active",
  },
  [BSL_STATUS.rejected]: {
    label: "Unavailable",
    icon: faLock,
    tone: "danger",
  },
};

export default function BslStatusBadge({ status }) {
  const meta = statusConfig[status] || statusConfig[BSL_STATUS.approved];

  return (
    <span className={`new-balance-status-badge is-${meta.tone}`}>
      <FontAwesomeIcon icon={meta.icon} />
      <span>{meta.label}</span>
    </span>
  );
}
